// eslint-disable-next-line
import i18n from "../../components/i18n";
import HeaderIndex from "./Header/Index";
import StacksIndex from "./Stacks/Index";
import ProjectsIndex from "./Projects/Index";

function HomeIndex() {
  return (
    <>
      <HeaderIndex />
      <StacksIndex />
      <ProjectsIndex />
    </>
  );
}

export default HomeIndex;
